module.exports = __webpack_public_path__ + "images/ExternalPromo/guitartricks_footer.gif?5051b";